import request from '@/utils/request';
import globalConfig from '@/global-config';

export function queryTableHeader(params) {
  return request({
    url: '/reconciliation/getReconciliationExcelHeader',
    method: 'get',
    params,
  });
}

export function queryExcelList(params) {
  return request({
    url: '/reconciliation/listExcelDownloadInfo',
    method: 'get',
    params,
  });
}

export function deleteExcel(params) {
  return request({
    url: '/reconciliation/deleteExcelInfo',
    method: 'get',
    params,
  });
}

export function generateExcel(data) {
  return request({
    url: '/reconciliation/exportReconciliationExcel',
    method: 'post',
    data,
  });
}

export function downLoadExcel(id) {
  const loginInfo = JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
  const { userName, sessionId } = loginInfo;

  window.open(`${globalConfig.host}/reconciliation/downloadReconciliationExcel?id=${id}&userName=${userName}&sessionId=${sessionId}`);
  // return request({
  //   url: '/reconciliation/downloadReconciliationExcel',
  //   method: 'get',
  //   params: { id },
  // });
}

export function updateTableHeader(data) {
  return request({
    url: '/reconciliation/updateHeaderInfo',
    method: 'post',
    data,
  });
}
